import {
  Box,
  Grid,
  Typography,
  Modal,
  ListItemAvatar,
  List,
  ListItem,
  Avatar,
  ListItemText
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import React, {useContext} from 'react';
import {useTranslation} from 'react-i18next';
import {makeStyles} from 'tss-react/mui';
import {AppContext} from '@/utils/appContext';
import websites from '../../../settings/websites';
import CloseIcon from "@mui/icons-material/Close";
import i18next from "i18next";

const ModalLanguages = (props: any) => {
  const appContext = useContext(AppContext);
  const useStyles = makeStyles()((theme) => {
    return {
      root: {
        width: 300,
        left: 0,
        top: '50%',
        position: 'absolute',
        right: 0,
        margin: 'auto',
        backgroundColor: 'white',
        transform: 'translate(0,-50%)',
        '.MuiListItem-root': {
          alignItems: 'center',
          cursor: 'pointer'
        },
        '.MuiAvatar-root': {
          backgroundColor: 'transparent'
        },
        [theme.breakpoints.down('sm')]: {
          width: '80%'
        }
      }
    };
  });

  const {t} = useTranslation();
  const {classes} = useStyles();
  const website = websites.find((website) => website.hostnames.includes(window.location.hostname));

  return (
    <Modal
      open={props.params.openLanguagesModal}
      onClose={() => props.params.handleModalLanguage()}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <Grid
        container
        alignItems={'center'}
        justifyContent={'space-evenly'}
        direction={'row'}
        className={classes.root}
        p={3}>

          {/*<Box sx={{position: 'absolute', left: 0, display: {xs: 'block', md: 'none'}}} p={3} pl={4}>
            <ArrowBackIcon onClick={() => props.params.handleModalLanguage()}/>
          </Box>*/}
          <Grid item xs={12} textAlign={'center'}>
            <Typography variant={'h4'} component={'h4'}>
              {t('Change_lang')}
            </Typography>
          </Grid>
          <Box sx={{position: 'absolute', right: -5, top: 5, cursor: 'pointer', display: {md: 'none', xl: 'block'}}}
               p={3} pl={4}>
            <CloseIcon onClick={() => props.params.handleModalLanguage()}/>
          </Box>

          <List sx={{width: '100%'}}>
            {website?.languages.map((lang: string, index: number) => (
              <ListItem
                key={index}
                onClick={() => {
                  i18next.changeLanguage(lang).then(() => {
                    localStorage.setItem('i18nextLng', lang);
                    appContext.setLanguage(lang);
                    props.params.handleModalLanguage();
                  })
                }}>
                <ListItemAvatar>
                  <Avatar>
                    <img
                      src={`https://huopenair.s3.eu-central-1.amazonaws.com/theme_hu/lingue/lingua_${lang}@2x.png`}
                      alt={lang}
                      width={30}
                    />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText primary={t(`lang_${lang}`)}/>
              </ListItem>
            ))}
          </List>
      </Grid>
    </Modal>
  );
};

export default ModalLanguages;
